/**
 * Remplace chaque occurrence de '&' par un nombre suivi d'un suffixe "er" ou "e".
 * Exemple: replaceAmp("& & &", 1) => "1er 2e 3e"
 *
 * @param {string} text - Chaîne contenant les caractères '&' à remplacer.
 * @param {number} start - Nombre de départ pour le comptage (par défaut 1).
 * @returns {string} Chaîne modifiée avec les remplacements.
 */
export function replaceAmp(text: string, start = 1): string {
  let counter = start;

  return text.replace(/&/g, () => {
    const suffix = counter === 1 ? 'er' : 'e';
    const result = `${counter}${suffix}`;
    counter++;
    return result;
  });
}
